<template>
  <v-toolbar id="toolbar" dense dark class="primary">
    <v-toolbar-side-icon @click="drawer" v-show="!backButton"></v-toolbar-side-icon>

    <v-btn icon dark @click="back" v-show="backButton">
      <v-icon>navigate_before</v-icon>
    </v-btn>

    <v-toolbar-title
      ><div>{{ title }}</div></v-toolbar-title
    >
    <v-spacer></v-spacer>
    <!-- <component :is="$store.state.tools"> </component> -->
    <slot name="buttons"> </slot>
  </v-toolbar>
</template>

<script>
export default {
  props: ['title', 'backButton'],
  methods: {
    drawer() {
      this.$store.commit('drawer', true)
    },
    back() {
      this.$emit('back')
    },
  },
}
</script>

<style lang="stylus">
.v-toolbar__content {
  padding: 0 16px !important;
}

.v-toolbar__title:not(:first-child) {
  margin-left: 10px !important;
}
</style>
